{
  "#PMSMELDUNG": {
    "QUERY": {
      "HEADER": "PMS-Meldungen abfragen",
      "FORM": {
        "ACTIONS": {
          "SUBMIT": "Abfrage starten",
          "RESET": "Zurücksetzen",
          "DATUM": {
            "VONDATUM": "Von-Datum",
            "BISDATUM": "Bis-Datum"
          }
        }
      }
    },
    "UEBERSICHT": {
      "CARD": {
        "PERSONALNUMMER": "Personalnummer",
        "NAME": "Name",
        "MELDUNGSCODE": "Meldungscode",
        "FEHLERTEXT": "Fehlertext",
        "OK_GEPRUEFT":"Ok/Geprüft",
        "AKTIV":"Aktiv",
        "AKTIV_JA":"Ja",
        "AKTIV_NEIN":"Nein"
      }
    }
  }
}
